var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Vcode',{attrs:{"show":_vm.showSlide,"canvasWidth":360,"canvasHeight":220,"range":5,"imgs":_vm.list},on:{"success":_vm.onSuccess,"fail":_vm.onFail,"close":_vm.handleClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }